export function portalToBody(el: HTMLElement): void {
  try {
    const doc = (el.ownerDocument || document) as Document;
    if (el.parentNode !== doc.body && doc.body) {
      doc.body.appendChild(el);
    }
  } catch {}
}

export function ensureFonts(doc: Document): void {
  try {
    if (!doc.querySelector('link[data-hollo-font="preconnect-gfonts"]')) {
      const l1 = doc.createElement("link");
      l1.setAttribute("rel", "preconnect");
      l1.setAttribute("href", "https://fonts.googleapis.com");
      l1.setAttribute("data-hollo-font", "preconnect-gfonts");
      doc.head?.appendChild(l1);
    }
    if (!doc.querySelector('link[data-hollo-font="preconnect-gstatic"]')) {
      const l2 = doc.createElement("link");
      l2.setAttribute("rel", "preconnect");
      l2.setAttribute("href", "https://fonts.gstatic.com");
      l2.setAttribute("crossorigin", "");
      l2.setAttribute("data-hollo-font", "preconnect-gstatic");
      doc.head?.appendChild(l2);
    }
    // WhatsApp uses system fonts, no need to load external fonts
    // Using WhatsApp's font stack: Segoe UI (Windows), Helvetica Neue (macOS), Helvetica, Arial, sans-serif
  } catch {}
}

export function lockBodyScroll(locked: boolean): void {
  try {
    const body = document.body as HTMLBodyElement;
    const html = document.documentElement as HTMLElement;
    if (locked) {
      body.style.overflow = "hidden";
      body.style.scrollBehavior = "none";
      html.style.overflow = "hidden";
      html.style.scrollBehavior = "none";
    } else {
      body.style.overflow = "visible";
      body.style.scrollBehavior = "auto";
      html.style.overflow = "visible";
      html.style.scrollBehavior = "auto";
    }
  } catch {}
}
